export default __webpack_public_path__ + "static/media/usersInactive.b7d527d4.svg";